import { tableCellClasses } from "@mui/material"

export const floatingCardWrapper = {
  p: { xs: 2, md: 3, lg: 4 },
  backgroundColor: "white",
  borderRadius: 4,
}

export const floatingTitle = {
  mb: { xs: 1, md: 1.5 },
  fontWeight: 700,
  textAlign: "center",
  fontSize: { xs: 32, lg: 40 },
  lineHeight: { xs: 1.5, lg: "3.5rem" },
}

export const floatingSubtitle = {
  mb: { xs: 2, lg: 2.5 },
  mx: "auto",
  maxWidth: "460px",
  textAlign: "center",
}

export const tableBox = {
  borderRadius: 2,
  boxShadow: "none",

  "& .MuiTableCell-root": {
    whiteSpace: "nowrap",
    "&.MuiTableCell-body": {
      height: 60,
    },
  },
}

export const tableHead = {
  "& .MuiTableCell-root": {
    px: 2,
    py: 1.5,
    minHeight: 150,
    fontSize: 13,
    lineHeight: "1.25rem",
    fontWeight: 400,
  },
}
export const tableEmptyWrapper = {
  borderTop: { xs: "1px solid #DCDCDC", md: "unset" },
  p: 2,
  display: "flex",
  width: "100%",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}

export const tableEmptyText = {
  fontWeight: 600,
  mb: 3,
}
export const tableBodyRow = {
  [`& .${tableCellClasses.root}`]: {
    border: "none",
    padding: 0,
  },
  verticalAlign: "middle",
}

export const normalText = {
  fontSize: 14,
  fontWeight: 500,
}

export const textCenter = {
  textAlign: "center",
  ...normalText,
}

export const textEnd = {
  textAlign: "end",
  ...normalText,
}

export const boldCenterCell = {
  ...textCenter,
  fontWeight: 700,
}

export const greyTitle = {
  color: "tableTitleGray",
  fontSize: 12,
}

export const iconWrapper = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 1,
}

export const actionsWrapper = {
  ...iconWrapper,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& .MuiButton-root": {
    fontSize: 14,
    fontWeight: 500,
  },
}

export const loadMoreWrapper = {
  mt: 2,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
}

export const loadMoreButton = {
  "&.MuiButton-root": {
    px: { md: 2.5 },
    py: { md: 2 },
    fontSize: { md: 16 },
  },
}

export const emptyText = {
  textAlign: "center",
  fontWeight: 500,
}

// Mobile

export const boxMobileWrapper = {
  display: "flex",
  flexDirection: "column",
}

export const titleItemWrapper = {
  mb: 5,
  backgroundColor: "white",
}

export const mobileCardWrapper = {
  py: 2,
  display: "flex",
  flexDirection: "column",
  gap: 1,
  borderTop: "1px solid #DCDCDC",
}

export const titleMobile = {
  pt: 1,
  pb: 1,
  px: 4,
  fontSize: 24,
  fontWeight: 700,
}

export const statWrapper = {
  px: 0,
  py: 1,
}

export const statTitleGray = {
  color: "tableTitleGray",
  fontSize: 13,
}

export const mobileSymbol = {
  fontSize: 18,
}

export const mobileActionWrapper = {
  padding: 1,
}
